import { Component } from '@angular/core';

declare const MW: any;
declare const pc: any;
declare const setupScene: any;
declare const MAP: any;

@Component({
  selector: 'app2',
  templateUrl: './app2.component.html'
})
export class App2Component {
  items = [];
  group;
  scene;

  ngOnInit() {
    this.scene = setupScene("canvas2");
    this.group = new pc.Entity("group", this.scene);
    this.group.setLocalScale(0.2, 0.2, 0.2);
    this.scene.root.addChild(this.group);
    this.add();
    this.add();
  }

  createCube(index) {
    var data = {};

    var cube = new pc.Entity("box" + index, this.scene);
    cube.addComponent("model", { type: "box" });

    var material = new pc.StandardMaterial();
    material.update();
    cube.model.material = material;
    this.group.addChild(cube);

    new MW.TwoWayMap({
        end1: data,
        map1: MAP.CUBE.to3DModel,
        end2: cube,
        map2: MAP.CUBE.toDataModel,
        data1: {
            color: "#ff9900",
            element: cube,
            index: index
        }
    });

    this.group.setLocalPosition(-index * 0.2, 0, 0);
    cube.setLocalPosition(index * 2, 0, 0);
    return data;
  }

  add() {
    this.items.push(this.createCube(this.items.length));
  }

  remove(index) {
    var mesh = this.items[index].element;
    this.group.removeChild(mesh);
    mesh.destroy();
    this.items.splice(index, 1);
    for (var i = index; i < this.items.length; i++) {
        this.items[i].index = i;
        var original = this.items[i].element.getLocalPosition();
        original.x = original.x - 2;
        this.items[i].element.setLocalPosition(original);
    }
    this.group.setLocalPosition(- (this.items.length - 1) * 0.2, 0, 0);
  }
}